<template>
  <div class="d-fx ai-c">
    <!--SEARCH Button  -->
    <i class="icon-search f-22px  mr-10px c-767676 cursor-pointer" @click="toggleSearch"></i>
    <ic-button value="SIGN IN" @click.native="showSign"></ic-button>
    <!-- User-Image Icon -->
    <!-- <div class="w-36px h-36px h-100 b-we bor-100 ml-18px cursor-pointer p-r">
      <img src="@/assets/images/HeaderC/profile.png" class="w-34px h-34px b-EAEAEA bor-100 p-a cen">
    </div> -->
  </div> 
</template>

<script>
import {mapStateVModel} from 'map-state-vmodel';

export default {
  name: 'notSignedC',
  extends: {},
  props: {},
  data(){
    return{};
  },
  components: {},
  computed: {
    ...mapStateVModel('header', ['searchBox']),
    ...mapStateVModel('sign', ['show']),
  },
  watch: {},
  methods: {
    toggleSearch() {
      this.searchBox = !this.searchBox
    },
    showSign() {
      this.show = true
    }
  },
  beforeCreate(){},
  mounted(){}
}
</script>
